export default function getFxRate(PaymentAmount, setRate, setDebitAmount, setRemittanceFee, setScreen, setShowOverlay, chosenPayee, currency, setError) {
  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      setRate(1.5);
      setDebitAmount(PaymentAmount * 1.5);
      setRemittanceFee(5);
      setScreen("ConfirmFxRate");
      setShowOverlay(false);
    }, 1000);
    setShowOverlay(true);
    return;
  }

  window.OrendaGetResponse(
    {
      event_name: "getFxRate",
      data: JSON.stringify({
        payeeId: chosenPayee.id,
        currency: chosenPayee.details.Currency,
        countryCode: chosenPayee.details.CountryCode,
        account: currency,
        paymentAmount: PaymentAmount,
      }),
    },
    (response) => {
      if (response.error) return setError(true);
      setRate(response.fx.rate);
      setDebitAmount(response.fx.amount);
      setRemittanceFee(response.Fee ? response.Fee.Value : null);
      setScreen("ConfirmFxRate");
      setShowOverlay(false);
      return;
    }
  );
  setShowOverlay(true);
  return;
}